import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import axios from 'axios';
import type { GenericErrorResponseError } from '@brainvaulttech/dgr-react-sdk';
import type { WorkOrderGetByIdResponse } from '@/types/workOrder.types';

type WorkOrderByIdQueryOptions = Omit<
  UseQueryOptions<WorkOrderGetByIdResponse, GenericErrorResponseError>,
  'queryKey' | 'queryFn' | 'enabled'
>;

export const useGetWorkOrderById = (workOrderId: string | undefined, options?: WorkOrderByIdQueryOptions) => {
  return useQuery<WorkOrderGetByIdResponse, GenericErrorResponseError>({
    queryKey: ['workOrder', workOrderId],
    queryFn: async () => {
      if (!workOrderId) throw new Error('Work Order ID is required');
      const response = await axios.get<WorkOrderGetByIdResponse>(`/work-orders/${workOrderId}`);
      return response.data;
    },
    enabled: !!workOrderId,
    ...options,
  });
};
